import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["iframe"]
  static values = { videoId: String }

  connect() {
    if (!window.Vimeo) {
      const script = document.createElement("script")
      script.src = "https://player.vimeo.com/api/player.js"
      script.onload = () => this.initializePlayer()
      document.head.appendChild(script)
    } else {
      this.initializePlayer()
    }
  }

  disconnect() {
    this.player?.destroy()
  }

  initializePlayer() {
    this.player = new window.Vimeo.Player(this.iframeTarget)
  }

  pause() {
    this.player?.pause()
  }

  play() {
    this.player?.play()
  }

  stop() {
    this.player?.pause()
    this.player?.setCurrentTime(0)
  }
}
